module.exports = __webpack_public_path__ + "media/educator_link_to_fastweb/fastweb_logo-5fc1e00d.png";